











































































































































































import { Component, Mixins, Watch } from "vue-property-decorator";
import { VIPUserEditComponentMixin } from '@/mixins/VIPUserMixin';
import Password from "vue-password-strength-meter";
import zxcvbn, { ZXCVBNResult } from "zxcvbn";
// import { auth } from '@/loader';

@Component({
	components: {
		"v-password": Password,
	},
})
export default class UserEdit extends Mixins(VIPUserEditComponentMixin) {
	public passwordTime: string = "";

	public get passwordInfo(): ZXCVBNResult {
		return zxcvbn(this.item?.password || "");
	}

	public get isAdmin(): boolean {
		return this.item?.isAdmin || false;
	}

	public get names(): string[] {
		let names: string[] = [];
		if (!this.item) {
			return names;
		}

		names.push(this.item.username);
		if (this.item.first_name) {
			names.push(this.item.first_name);
		}
		if (this.item.last_name) {
			names.push(this.item.last_name);
		}
		if (this.item.first_name && this.item.last_name) {
			names.push(`${this.item.first_name} ${this.item.last_name}`);
			names.push(`${this.item.last_name} ${this.item.first_name}`);
			names.push(`${this.item.first_name?.substr(0, 1)}. ${this.item.last_name}`);
		}

		return names;
	}

	public focused = {
		username: false,
		email: false,
		first_name: false,
		last_name: false,
		position: false,
		password: false,
		confirmPassword: false,
		roles: false,
	};

	public invalidFeedbacks = {
		username: "L'identifiant doit être entre 1 et 60 caractères",
		email: "L'email n'est pas valide",
		first_name: "",
		last_name: "",
		position: "",
		password: "",
		confirmPassword: "Les deux mots de passe ne sont pas identiques.",
		roles: "Au moins un rôle doit être actif."
	};

	public get states() {
		return {
			username: this.focused.username ? this.item.username?.length > 0 && this.item?.username?.length < 60 : null,
			email: this.focused.email ? this.item.email?.length <= 255 && /^[a-zA-Z0-9_.+-]+@[a-zA-Z0-9-]+\.[a-zA-Z0-9-.]+$/.test(this.item.email) : null,
			first_name: this.focused.first_name ? true : null,
			last_name: this.focused.last_name ? true : null,
			position: this.focused.last_name ? true : null,
			password: this.focused.password ? !this.item.password || !this.invalidFeedbacks.password : null,
			confirmPassword: this.item.password && this.focused.confirmPassword ? this.item.password === this.item.confirmPassword : null,
			roles: this.focused.roles ? !!this.item.roles.length : null,
		};
	}

	public loginKeypress(event: KeyboardEvent) {
		if (!/[a-z0-9@._-]/.test(event.key)) {
			event.preventDefault();
		}
	}

	@Watch("item.password", { immediate: true })
	public passwordChanged(newValue?: string | null, oldValue?: string | null) {
		if (newValue && newValue !== oldValue) {
			let passwordInfo = zxcvbn(newValue, [this.item.last_name || "", this.item.first_name || "", this.item.username, this.item.email]);
			let { suggestions, warning } = passwordInfo.feedback;
			suggestions.unshift(warning);
			this.invalidFeedbacks.password = suggestions.filter(x => !!x).map(s => s.endsWith(".") ? s : s + ".").join(" ").trim();

			let values = Object.entries(passwordInfo.crack_times_seconds).sort(([,aSec], [,bSec]) => aSec - bSec);
			let [min,] = values[0];
			let [max,] = <[string, number]>values.pop();
			// @ts-ignore
			min = passwordInfo.crack_times_display[min];
			// @ts-ignore
			max = passwordInfo.crack_times_display[max];
			this.passwordTime = `Il faudra ${min === max ? min : `entre ${min} et ${max}`} pour découvrir votre mot de passe.`;
		}
	}
}
